import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormPayMethods } from './FormPayMethods';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { DeletePayMethods } from './DeletePayMethods';
import { Dialog } from 'primereact/dialog';

export const ModalPayMethods = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, abbreviation, handleInputChange, validaciones,
        saveCreate, saveUpdate, saveDelete
    } = props;

    const footer = (
        <>
            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>
        </>

    );



    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            modal
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-credit-card f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}
            footer={footer}>
            {
                method === "create"
                    ? <FormPayMethods button={ModalButtonSave} {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }} />
                    : (method === "update")
                        ? <FormPayMethods button={ModalButtonUpdate} {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }} />
                        : null
            }
        </Dialog>
    )
}
